module.exports = __webpack_public_path__ + "img/aero.7c5ab64a.webp";